export default function SET_REGION(state, regionData) {
    state.region = regionData;
}